import { Space, Col, Row } from 'antd'
import { useState } from 'react'

import { CardSection, Loader } from 'components'

import {
  Chart,
  StyledButton,
  StyledCol,
  ChartsRow,
  ExportButton,
  NoData,
  HarvestedBall,
  NextTwoWeeksHarvestedBall,
  LegendText,
  MarginColumn,
} from './components'
import { ChartData } from './types'
import { LoaderContainer } from '../ChartsCard/components'

const updateTypes = [
  { text: 'Cosechado', ball: <HarvestedBall /> },
  { text: 'A cosechar (próximos 15 días)', ball: <NextTwoWeeksHarvestedBall /> },
]

interface Props {
  lotsChartData: ChartData[]
  sizeChartData: ChartData[]
  loading?: boolean
}

export const CompaniesHarvestCard: React.FC<Props> = ({
  loading,
  lotsChartData,
  sizeChartData,
}) => {
  const [activeView, setActiveView] = useState<'lots' | 'size'>('size')
  const isLotsActiveView = activeView === 'lots'
  const isAreaActiveView = activeView === 'size'
  const data = isLotsActiveView ? lotsChartData : sizeChartData
  const existData = !!data.length

  return (
    <CardSection title="Cosecha por productor" actionBar={<ExportButton />}>
      {loading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <>
          <MarginColumn span={24}>
            <Row justify="end">
              <StyledCol span={12}>
                <Space size={16}>
                  <StyledButton
                    type={isAreaActiveView ? 'default' : 'text'}
                    onClick={() => setActiveView('size')}
                  >
                    Hectáreas
                  </StyledButton>
                  <StyledButton
                    type={isLotsActiveView ? 'default' : 'text'}
                    onClick={() => setActiveView('lots')}
                  >
                    Lotes
                  </StyledButton>
                </Space>
              </StyledCol>
              <Space size={24}>
                {updateTypes.map(({ text, ball }) => (
                  <Row gutter={8} align="middle" key={text}>
                    <Col>{ball}</Col>
                    <Col>
                      <LegendText>{text}</LegendText>
                    </Col>
                  </Row>
                ))}
              </Space>
            </Row>
          </MarginColumn>

          {existData ? (
            <ChartsRow gutter={[{ xl: 24 }, { xs: 24, md: 24, xl: 0 }]}>
              <Col xs={24}>
                <Chart data={data} isAreaActiveView={isAreaActiveView} />
              </Col>
            </ChartsRow>
          ) : (
            <NoData />
          )}
        </>
      )}
    </CardSection>
  )
}
